module.exports = __webpack_public_path__ + "img/gmr.1705da0e.svg";